import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#0597A3"
      d="M101.5 90.59c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#00D8D8"
      d="M94 15.22a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6.57 52.79a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M15.15 86.58l3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM110.63 26.69h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M58 19h26.46c4.17 0 7.54 3.34 7.54 7.45v63.09c0 4.12-3.38 7.45-7.54 7.45H31.55c-4.17 0-7.54-3.34-7.54-7.45V26.45c0-4.12 3.38-7.45 7.54-7.45h26.46"
    />
    <path
      fill="#001A43"
      d="M44.55 55.04h-.1c-.63-.03-1.22-.32-1.62-.8l-5.21-6.18a2.25 2.25 0 0 1 3.44-2.9l3.63 4.3 8.47-8.47c.88-.88 2.3-.88 3.18 0s.88 2.3 0 3.18l-10.21 10.2c-.42.42-1 .66-1.59.66zM48.18 74l4.07-4.07c.88-.88.88-2.3 0-3.18s-2.3-.88-3.18 0L45 70.82l-4.07-4.07c-.88-.88-2.3-.88-3.18 0s-.88 2.3 0 3.18L41.82 74l-4.07 4.07a2.25 2.25 0 0 0 1.59 3.84c.57 0 1.15-.22 1.59-.66L45 77.18l4.07 4.07c.44.44 1.02.66 1.59.66a2.25 2.25 0 0 0 1.59-3.84z"
    />
    <path
      fill="#0597A3"
      d="M67.8 15.22h-3.58A6.22 6.22 0 0 0 58 9c-3.43 0-6.22 2.79-6.22 6.22H48.2c-3.68 0-6.67 2.99-6.67 6.67 0 3.69 2.99 6.67 6.67 6.67h19.61c3.68 0 6.67-2.99 6.67-6.67 0-3.69-2.99-6.67-6.67-6.67zM58 17.54a2.69 2.69 0 0 1-2.69-2.69c0-1.48 1.21-2.69 2.69-2.69s2.69 1.21 2.69 2.69-1.21 2.69-2.69 2.69"
    />
  </svg>
);
const SvgEnrichedIconJobsInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconJobsInverted);
export default Memo;
